import { Color } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { NODE_ICON_SOURCES } from 'dashboard/lib/utils/graph';
import { DatumTypeToken, NodeRenderConfig } from 'dashboard/models/graph';

const IconContainer = styled.span<GraphV2VertexIconProps>`
  background-color: ${(props) => {
    if (props.backgroundNone) {
      return 'transparent';
    } else if (props.dimmed) {
      return Color.CoreSlate200;
    } else {
      return props.nodeRenderConfig?.color?.toString();
    }
  }};

  border-radius: 5px;
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  text-align: center;
  vertical-align: middle;
  position: relative;
`;

const Icon = styled.img<GraphV2VertexIconProps>`
  display: block;
  margin: auto;
  position: absolute;
  width: 1em;
  height: 1em;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  filter: ${(props) => {
    if (props.dimmed) {
      // Make icon gray
      return 'brightness(0.5)';
    }
    if (props.backgroundNone) {
      // Make icon black
      return 'invert(1)';
    } else {
      return 'none';
    }
  }};
`;

interface GraphV2VertexIconProps {
  version: 'v2';
  datumTypeToken: DatumTypeToken;
  backgroundNone?: boolean;
  dimmed?: boolean;
  nodeRenderConfig: NodeRenderConfig;
}

const GraphVertexIcon = (props: GraphV2VertexIconProps) => {
  return (
    <IconContainer {...props}>
      <Icon {...props} src={NODE_ICON_SOURCES[props.nodeRenderConfig.icon]} />
    </IconContainer>
  );
};

export default GraphVertexIcon;
